<template>
  <div class="key-container">
    <ul>
      <li v-for="item in keyCategoryList" :key="item.image">
        <a href="javascript:;" @click="toICourse(item.id)" class="key-icon-table">
          <img :src="item.image" class="key-icon">
          <span class="key-text">{{item.categoryName}}</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import '../../../assets/css/index.css'
import {ApiGetKeyCategory} from '../../../net/home/index.js'
export default {
  data: function () {
    return {
      keyCategoryList: []
    }
  },
  methods:{
    getKeyCategory: function () {
      ApiGetKeyCategory().then(res=>{
        if (res.code == 200) {
          this.keyCategoryList = res.value
        }
      })
    },
    toICourse: function (id) {
      this.$router.push({ path: '/ICourse', query: { id: id }})
    }
  },
  mounted: function () {
    this.getKeyCategory()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Home/children/typeCade.vue